export const WHEREBY_ENDPOINT_PUBLICAPI =
    process.env.WHEREBY_ENDPOINT_PUBLICAPI ||
    (process.env.NODE_ENV === "development" ? "https://localhost:8090" : "https://api.whereby.dev");
export const WEB_BASE_URL = process.env.GATSBY_WEB_BASE_URL || "https://whereby.com";

// embedded explore plan
export const EXPLORE_MINUTES = 2000;

// embedded build plan
export const BUILD_PRICE = "$9.99";
export const BUILD_MINUTES = 2000;
export const BUILD_PRICE_PER_MINUTE = 0.004;
export const BUILD_RECORDING_STREAMING_PER_MINUTE = 0.01;

// embedded grow plan
export const GROW_INCLUDED_RECORDING_MINUTES = 3000;
export const GROW_INCLUDED_STREAMING_MINUTES = 1000;
export const GROW_INCLUDED_PARTICIPANT_MINUTES = 65000;
export const GROW_RECORDING_STREAMING_PER_MINUTE = 0.01;
export const GROW_BASE_TIER = 0.004;
export const GROW_BASE_PRICE = 299;
// price per montlhy participant minutes
export const GROW_PRICING_PER_MONTHLY_PM = {
    99_000_000_000: 0.0013,
    16_600_000: 0.0021,
    6_200_000: 0.0025,
    2_100_000: 0.0027,
    840_000: 0.003,
    410_000: 0.0034,
    125_000: 0.0037,
    65_000: 0.0,
};

export const MAX_PARTICIPANTS = 600;
